import { Cart } from '@providers/ShoppingCart';
import { useContext } from 'react';
import { RootContext } from '@context/RootContext';
import { DiscountCode, DiscountCodeProduct } from '@typings/api-models';

type DiscountCodeWithProducts = DiscountCode & { products: DiscountCodeProduct[] };

type UseCartOutput = { cart: Cart; discountCode: DiscountCodeWithProducts | null };

type RootContextData = {
  cart: {
    data: {
      discountCodes: Record<string, DiscountCodeWithProducts | null>;
      carts: Record<string, Cart>;
    };
  }
};

const selectCreatorCart = (creatorSlug: string) => (context: RootContextData): UseCartOutput => {
  const cart = (context?.cart?.data?.carts || {})[creatorSlug] || [];
  const discountCode = (context?.cart?.data?.discountCodes || {})[creatorSlug];
  return { cart, discountCode };
};

type RootContextInterface = {
  getContextSection: (selector: (context: RootContextData) => UseCartOutput) => UseCartOutput;
  setContextSection: (props: { data: Cart, section: 'cart' }) => void;
};

const useCart = ({ creatorSlug }: { creatorSlug: string }): UseCartOutput => {
  const { getContextSection } = useContext(RootContext) as unknown as RootContextInterface;
  return getContextSection(selectCreatorCart(creatorSlug as string));
};

export default useCart;
